import React from "react";
import { useState } from "react";
import axios from "axios";
import Spinner from "./Spinner";
import Logo from "./Group 4.png";

function LoginForm() {
  const [userName, setuserName] = useState("");
  const [userSecret, setuserSecret] = useState("");
  const [waiting, setwaiting] = useState(false);
  const [error, seterror] = useState(false);
  console.log(userName, userSecret);

  const handelSubmit = async (e) => {
    e.preventDefault();
    setwaiting(true);
    const authObject = {
      "Project-ID": "cc108e84-5257-4bea-8802-18f6d0ebf7a0",
      "User-Name": userName,
      "User-Secret": userSecret,
    };
    try {
      await axios.get("https://api.chatengine.io/chats", {
        headers: authObject,
      });
      localStorage.setItem("userName", userName);
      localStorage.setItem("password", userSecret);
      window.location.reload();
      setwaiting(true);
    } catch (error) {
      console.log(error);
      setwaiting(false);
      seterror(true);
    }
  };
  return (
    <div className="wrapper">
      <div className="form">
        <div className="upperPart">
          <img src={Logo} alt="logo" />
          <h1>Text Share</h1>
        </div>
        <form action="" onSubmit={handelSubmit}>
          <div>
            <input
              type="text"
              placeholder="User Name"
              value={userName}
              className="input"
              required
              onChange={(e) => {
                setuserName(e.target.value);
              }}
            />
          </div>
          <div>
            <input
              type="password"
              value={userSecret}
              placeholder=" SecretID"
              onChange={(e) => setuserSecret(e.target.value)}
            />
          </div>
          <button type="submit">Enter</button>
        </form>
        <div>
          <button
            className="btn_gust"
            onClick={() => {
              setuserName("Guest-1");
              setuserSecret("321");
            }}
          >
            Guest-1
          </button>
          <button
            className="btn_gust"
            className="btn_gust"
            onClick={() => {
              setuserName("Guest-2");
              setuserSecret("321");
            }}
          >
            Guest-2
          </button>
        </div>
        <div>{waiting ? <Spinner /> : ""}</div>
        <div className="errorWarn">
          {error ? <span>Authentication Faild! Wrong Credentials</span> : ""}
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
